/**
 * Botón de pestaña para las fichas de detalle (`DetailView`).
 *
 * ¿Por qué no un `<button>`? En las fichas el cuerpo va envuelto en un
 * `<fieldset disabled={!editing}>` para apagar de golpe todos los campos en
 * modo lectura. Un `<fieldset disabled>` desactiva también sus `<button>`
 * descendientes, así que la barra de pestañas quedaba inerte en lectura y no
 * se podía cambiar de pestaña hasta pulsar "Editar". Un `<div role="tab">`
 * no es un control de formulario, por lo que el fieldset no lo bloquea; el
 * teclado (Enter / Espacio) se emula aquí para no perder accesibilidad.
 */
export default function TabButton({ className = '', onClick, children, type, disabled, ...rest }) {
  const active = /(^|\s)active(\s|$)/.test(className);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.(event);
    }
  };

  return (
    <div
      {...rest}
      role="tab"
      aria-selected={active}
      tabIndex={0}
      className={className}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      {children}
    </div>
  );
}
